import React, { useMemo, useEffect, useState } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import { Link, useNavigate } from "react-router-dom";
import { Table, Row, Col, Modal, Form } from "reactstrap";
import Pagi2 from "common/utils/Pagi2";

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import imgMilestone from "../../assets/images/AddMilestone.jpg";
import milestone from "../../assets/images/viewNotes.jpg";

import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import { CommonTableContainer } from "common/utils/ComonTableContainer";

const milestoneType = [
    { label: "Milestone - Design", value: "1", type: "Design", text: "DS" },
    { label: "Milestone - Development", value: "2", type: "Development", text: "DE" },
    { label: "Milestone - Testing", value: "3", type: "Testing", text: "T" },
    { label: "Milestone - Deployment", value: "4", type: "Deployment", text: "DP" },
    { label: "Milestone - UAT", value: "5", type: "UAT", text: "U" },
]

const ViewMileStone = ({ data }) => {

  const [viewModal, setViewModal] = useState(false);
  const [milestoneSidebar, setMilestoneSidebar] = useState(false);
  const [editMilestoneSidebar, setEditMilestoneSidebar] = useState(false);
  const [viewMilestoneDetails, setViewMilestoneDetails] = useState(false);
  const [MilesotneData, setMilestoneData] = useState({});

  const navigate = useNavigate();

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setViewMilestoneDetails(false);
  });

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center",
      },
      {
        Header: "Milestone",
        accessor: "milestone_no",
        isInfoIcon: false,
        Cell: (cellProps) => {
          // console.log()
          return <a>Milestone {cellProps.cell.value}</a>;
        },
      },
      // {
      //     Header: "Hours",
      //     accessor: "hours",
      //     isInfoIcon: false,
      //     className: "col-1 text-center"
      // },
      {
        Header: "Description",
        accessor: "description",
        isInfoIcon: false,
        className: "col-7",
        Cell: (cellProps) => {
          return <a
            dangerouslySetInnerHTML={{__html : cellProps.cell.value}}
          >

          </a>;
        },
      },
      {
        Header: "Action",
        accessor: "action ",
        className: "text-center",
        Cell: (cellProps) => {
          return (
            <div className="text-center">
              <button
                className="btn btn-sm btn-outline-secondary"
                title="View Milestone"
                onClick={() => {
                  setViewMilestoneDetails(true);
                  setMilestoneData(cellProps.cell?.row?.values);
                }}
              >
                <i className="fas fa-eye "></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  // const data = useMemo(
  //   () => [
  //     {
  //       id: 1,
  //       milestone: "Milestone 1",
  //       hours: "2",
  //       desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. ",
  //     },
  //     {
  //       id: 2,
  //       milestone: "Milestone 2",
  //       hours: "2",
  //       desc: "Popular belief, Lorem Ipsum is not simply random text.",
  //     },
  //     {
  //       id: 3,
  //       milestone: "Milestone 3",
  //       hours: "2",
  //       desc: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
  //     },
  //     {
  //       id: 4,
  //       milestone: "Milestone 4",
  //       hours: "2",
  //       desc: "The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.",
  //     },
  //   ],
  //   []
  // )

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);
  return (
    <>
      <div className="px-0 mt-4">
        <Row>
          <Col>
            <select
              className="border-radius me-4 form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
          <Col className="d-flex justify-content-end align-items-start mb-4">
            <div>
              <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                <div className="position-relative">
                  <label htmlFor="search-bar-0" className="search-label">
                    <span id="search-bar-0-label" className="sr-only">
                      Search this table
                    </span>
                    <input
                      onChange={(e) => setGlobalFilter(e.target.value)}
                      id="search-bar-0"
                      type="text"
                      className="border-radius form-control rounded h-100"
                      placeholder={`Search...`}
                      value={globalFilter || ""}
                    />
                  </label>
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
            <div className="text-center">
              <img src={imgMilestone} alt="Addepe" style={{ width: "90%" }} />
            </div>
          </div>
          <div className="position-relative col-md-8 d-flex justify-content-end align-items-center ps-3">
            <CommonTableContainer data={data} columns={columns} status={true} />
          </div>
        </Row>

        {/* Pagination */}
        <Row className="justify-content-md-end justify-space-between align-items-center">
          <Pagi2
            gotoPage={gotoPage}
            previousPage={previousPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
          />
        </Row>
      </div>

      {/* View Milestone details  */}
      <div
        className={`note-sticky-form ${
          viewMilestoneDetails ? "d-block" : "d-none"
        }`}
      >
        <Draggable>
          <ResizableBox
            width={1000}
            style={{
              position: "fixed",
              top: "10%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">View Milestone Details</h5>
              <button
                type="button"
                onClick={() => setViewMilestoneDetails(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <div className="modal-body pe-4">
              <Form
                // onSubmit={handleEditSubmit}
                className="row d-flex justify-content-center align-items-center"
              >
                <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
                  <div className="text-center">
                    <img
                      src={milestone}
                      alt="Addepe"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>

                <div className="col-md-7 d-flex flex-column ">
                  <div className="col-6 mb-3">
                    <label htmlFor="">Milestone</label>
                    <input
                      className="form-control"
                      value={milestoneType.filter(item => item?.value == MilesotneData?.milestone_no)[0]?.label}
                      disabled
                    ></input>
                  </div>
                  <div className="col-12">
                    <label htmlFor="">Description</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      cols="50"
                      disabled
                      value={MilesotneData?.description?.replace(/<[^>]+>/g, '')}
                    ></textarea>
                  </div>

                  <div className="my-4 text-end">
                    <a
                      onClick={() => setViewMilestoneDetails(false)}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </>
  );
};

export default ViewMileStone;
